import { Map } from 'immutable';

import { aiGenerated } from './ai';
import { tagsToList, tagsToString } from '../../../tags';
import { getSize } from '../../../iterable/getSize';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';

export function tags({ channel, operation, preview, state }) {
  switch (operation) {
    case OPERATIONS[channel].TAGS.AI_GENERATED: {
      return aiGenerated({ attribute: ATTRIBUTE.TAGS, channel, preview, state });
    }

    default: {
      const payload = [];

      switch (operation) {
        case OPERATIONS[channel].TAGS.CHANGE_TO: {
          if (getSize(preview.getIn([ATTRIBUTE.TAGS, ATTRIBUTE.TAGS]))) {
            payload.push(
              Map({
                type: operation,
                value: tagsToList({ channel, tags: preview.getIn([ATTRIBUTE.TAGS, ATTRIBUTE.TAGS]) }),
              })
            );
          }

          break;
        }

        default: {
          if (getSize(preview.getIn([ATTRIBUTE.TAGS, ATTRIBUTE.TAGS]))) {
            payload.push(
              Map({
                type: operation,
                value: tagsToString({ channel, tags: preview.getIn([ATTRIBUTE.TAGS, ATTRIBUTE.TAGS]) }),
              })
            );
          }

          break;
        }
      }

      return {
        payload,
      };
    }
  }
}
